<template lang="pug">
    v-dialog( v-model="showInviteFriend" width="450px")
        div(class="popup-title")
            span() {{ $t('Invite_a_friend') }}

        div()
            div()
                div(style="margin-bottom:4px;display:block") {{ $t('Invite_Email') }}
                v-text-field(
                    v-model="friendEmail"
                    outlined dense solo flat
                    :hide-details="true"
                    style=""
                    label="Friend's email")
            div()
                v-btn(class="btn-primary mt-3" @click="sendEmail") {{ $t('Invite') }}

            //- Popup to inform error to send email
            v-dialog(v-model="emailError" width="450px" style="height: 100%;")
                div(class="")
                    span {{ $t('write_valid_email') }}

            //- Popup to inform email sended
            v-dialog(v-model="emailSended" width="450px")
                div(class="")
                    span {{ $t('email_has_been_sent') }}
</template>

<script>
import ApiService from "../../Services/ApiService";
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: "UserInviteFriend",
    props: {
        value: Boolean
    },
    data () {
        return {
            showInviteFriend: false,
            emailError: false,
            emailSended: false,
            friendEmail: "",
            user: null,
        }
    },
    computed: {
        ...mapGetters([
            'getShowUserInviteFriend'
        ])
    },
    watch: {
        getShowUserInviteFriend() {
            if(this.getShowUserInviteFriend === true) {
                // console.log('Gick in?');
                this.showInviteFriend = true;

                this.setShowUserInviteFriend(false);
            }
        }
    },
    methods: {
        ...mapMutations([
            'setShowUserInviteFriend'
        ]),
        validateEmail (emailAdress) {
            let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (emailAdress.match(regexEmail)) {
                return true; 
            } else {
                return false; 
            }
        },

        // let emailAdress = "test@gmail.com";
        // console.log(validateEmail(emailAdress));
        async sendEmail(){
            const user = await ApiService.findUser(JSON.parse(localStorage.user).user_id);
            this.user = user;

            const requestBody = {
                userEmail: this.user.email,
                friendEmail: this.friendEmail
            };

            const validate = this.validateEmail(this.friendEmail);

            if(validate){
                this.emailSended = true;
                await ApiService.sendInvitationToFriend(requestBody);
            } else {
                this.emailError = true;
            }
        }
    }
}
</script>

<style scoped>

>>>.v-dialog {
    padding: 22px;
    background: white;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 0 12px rgba(0,0,0,.3);
    border-radius:8px;
}

>>>.v-dialog .v-dialog {
    box-shadow: none;
}

>>>.v-dialog .v-input__slot {
    border: 1px solid rgba(20,75,77,1);
    min-height: 32px !important;
}

>>>.v-dialog .v-input__slot .v-label {
    font-size: 12px;
    top: 6px;
}

>>>.v-dialog fieldset {
    border: 0 !important;
}
</style>
